import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ChatTableContent } from '../ai-broker-chat.models';

@Component({
  selector: 'app-chat-table',
  standalone: true,
  imports: [CommonModule, TableModule],
  template: `
    <div class="table-container surface-card border-round-lg border-1 border-gray-300 overflow-hidden my-2">
      <p-table [value]="data().rows" [columns]="data().columns" 
               [responsiveLayout]="'scroll'" styleClass="p-datatable-sm p-datatable-gridlines">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" class="bg-gray-50 font-bold text-xs">
              {{ col | titlecase }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td *ngFor="let col of columns" class="text-sm">
              {{ rowData[col] }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  `,
  styles: [`
    .table-container {
      max-width: 100%;
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }
    :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
      padding: 0.75rem 1rem;
      background: var(--surface-50);
      color: var(--text-color);
      border-bottom: 2px solid var(--border-gray-300);
    }
    :host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
      padding: 0.75rem 1rem;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatTableComponent {
  data = input.required<ChatTableContent>();
}
